;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');
	Model.Validations = Backbone.Model.extend({
		defaults: {
			first_name_required: {
				type: 'required',
				field: 'first_name',
				message: 'First name - is required field'
			},
			first_name_regexp: {
				type: 'regexp',
				field: 'first_name',
				regexp: /^[A-Za-z\s\W]+$/,
				message: 'First name must contain only alpha characters.'
			},
			last_name_required: {
				type: 'required',
				field: 'last_name',
				message: 'Last name - is required field'
			},
			last_name_regexp: {
				type: 'regexp',
				field: 'last_name',
				regexp: /^[A-Za-z\s\W]+$/,
				message: 'Last name must contain only alpha characters.'
			},
			pseudo_name_required: {
				type: 'required',
				field: 'pseudo_name',
				message: 'Pseudo name - is required field'
			},
			pseudo_name_regexp: {
				type: 'regexp',
				field: 'pseudo_name',
				regexp: /^[A-Za-z0-9_]+$/,
				message: 'Pseudo name must contain only alpha characters.'
			},
			pseudo_name_length: function(value, formValues) {
				var err = {
					type: 'length',
					field: 'pseudo_name',
					message: 'Must contain between 6 and 30 characters'
				};
				if (value.length < 6 || value.length > 30) return err;
			},
			pseudo_name_not_eurosport: function(value, formValues) {
				var err = {
						// type: 'length',
						field: 'pseudo_name',
						message: 'Cannot contain the word “Eurosport”'
					},
					reg = new RegExp(/eurosport/i),
					search_word = value.search(reg);

				if (search_word!== -1) return err;
			},
			email_required: {
				type: 'required',
				field: 'email',
				message: 'Email - is required.'
			},
			email_validation: {
				type: 'email',
				field: 'email',
				message: function(obj) {
					return obj.value + ' - is an invalid email address.'
				}
			},
			email_match: {
				type: 'match',
				field: 'email',
				message: 'Emails must match!'
			},
			confirm_email_required: {
				type: 'required',
				field: 'confirm_email',
				message: 'Email - is required.'
			},
			confirm_email_validation: {
				type: 'email',
				field: 'confirm_email',
				message: function(obj) {
					return obj.value + ' - is an invalid email address.'
				}
			},
			confirm_email_match: {
				type: 'match',
				field: 'confirm_email',
				message: 'Emails must match!'
			},
			password_required: {
				type: 'required',
				field: 'password',
				message: 'Password - is required field'
			},
			password_match: {
				type: 'match',
				field: 'password',
				message: 'Passwords must match!'
			},
			password_regexp: {
				type: 'regexp',
				field: 'password',
				regexp: /.{8,}/,
				message: 'Minimum required password length is 8 symbols'
			},
			passwordConfirm_required: {
				type: 'required',
				field: 'passwordConfirm',
				message: 'Password - is required field'
			},
			passwordConfirm_match: {
				type: 'match',
				field: 'passwordConfirm',
				message: 'Passwords must match!'
			},
			passwordConfirm_regexp: {
				type: 'regexp',
				field: 'passwordConfirm',
				regexp: /.{8,}/,
				message: 'Minimum required password length is 8 symbols'
			},
			birthday_required: {
				type: 'required',
				field: 'birthday',
				message: 'Birthday - is required field'
			},
			birthday_greater_eighteen: function(value, formValues) {
				let
					dateParts = value.match(/(\d+)/g),
					realDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]),
					err = {
						type: 'required',
						message: 'You must be over 18 years old to register'
					};
				var today = new Date(),
					birthday = new Date(realDate),
					age = today.getFullYear() - birthday.getFullYear(),
					m = today.getMonth() - birthday.getMonth();

				if (m < 0 || (m===0 && today.getDate() < birthday.getDate())) {
					age--;
				}
				if (age < 18) return err;
			},

			birthday_formated_greater_eighteen: function(value, formValues){

				let
					dateParts = value.match(/(\d+)/g),
					realDate = new Date( dateParts[2],dateParts[0]- 1, dateParts[1] ),
					err = {
						type: 'required',
						message: 'You must be over 18 years old to register'
					};

				var today = new Date(),
					birthday = new Date(realDate),
					age = today.getFullYear() - birthday.getFullYear(),
					m = today.getMonth() - birthday.getMonth();

				if (m < 0 || (m===0 && today.getDate() < birthday.getDate())) {
					age--;
				}

				if (age < 18) return err;
			},

			mobile_required: {
				type: 'required',
				field: 'mobile',
				message: 'Mobile - is required field'
			},
			mobile_required_for_AU: function checkCountry(value, formValues) {
				var err = {
					type: 'required',
					field: 'mobile',
					message: 'Mobile is required for Australia'
				};
				if (formValues.country=='AU' && !value) return err;
			},
			mobile_is_number: {
				type: 'number',
				field: 'mobile',
				message: 'Mobile should be a number'
			},
			mobile_length: function checkLength(value, formValues) {
				var err = {
					type: 'length',
					field: 'mobile',
					message: 'Mobile should contain minimum nine characters'
				};
				if (value.length < 9 && value.length > 0) return err;
			},
			team_name_required: {
				type: 'required',
				field: 'team_name',
				message: 'Team name - is required field'
			},
			sportsmail_required: function(callback, editor) {
				if (!callback) {
					var err =
						{
							type: 'required',
							field: 'sprotsmail',
							message: 'This field is required'
						};
					return err;
				}
			},
			crownbet_required: {
				type: 'required',
				field: 'news',
				message: 'CrownBet\'s privacy policy - is required field'
			},
			team_name_regexp: {
				type: 'regexp',
				field: 'team_name',
				regexp: /^[A-Za-z\s\d\W]+$/,
				message: 'Team name must contain only alpha characters and numbers.'
			},
			username_teamname_regexp: {
				type: 'regexp',
				field: 'team_name',
				regexp: /^[A-Za-z\s\d\W]+$/,
				message: 'Username must contain only alpha characters and numbers.'
			},

			tipster_name_required: {
				type: 'required',
				field: 'team_name',
				message: 'Tipster name - is required field'
			},
			tipster_name_regexp: {
				type: 'regexp',
				field: 'team_name',
				regexp: /^[A-Za-z\s\d\W]+$/,
				message: 'Tipster name must contain only alpha characters and numbers.'
			},
			nickname_required: {
				type: 'required',
				field: 'team_name',
				message: 'Nickname is a required field'
			},
			nickname_regexp: {
				type: 'regexp',
				field: 'team_name',
				regexp: /^[A-Za-z\s\d\W]+$/,
				message: 'Nickname name must contain only alpha characters and numbers.'
			},
			team_supported_required: function(value, formValues) {
				var err = {
					type: 'required',
					field: 'team_supported',
					message: 'Team Supported - is required'
				};
				if (!value || value==0) return err;
			},


			club_supported_required: function(value, formValues) {
				var err = {
					type: 'required',
					field: 'team_supported',
					message: 'Favourite club - is required'
				};
				if (!value || value==0) return err;
			},
			terms_required: function(callback, editor) {
				if (!callback) {
					var err =
						{
							type: 'required',
							field: 'terms',
							message: 'You must accept Terms & Conditions'
						};
					return err;
				}
			},
			over_18_required: function(callback, editor) {
				if (!callback) {
					var err =
						{
							type: 'required',
							field: 'is_over_18',
							message: 'Please check this box to confirm eligibility'
						};
					return err;
				}
			},

			news_required: function(callback, editor) {
				if (!callback) {
					var err =
						{
							type: 'required',
							field: 'news',
							message: ''
						};
					return err;
				}
			},
			secondary_sponsor_required: function(callback, editor) {
				if (!callback) {
					var err =
						{
							type: 'required',
							field: 'secondary_sponsor',
							message: 'You must agree to receiving direct communications'
						};
					return err;
				}
			},
			cbus_id_required: {
				type: 'required',
				field: 'cbus_id',
				message: 'Cbus Member ID - is required field'
			},
			cbus_id_number: {
				type: 'number',
				field: 'cbus_id',
				message: 'Cbus Member ID should be a number'
			},
			cbus_id_length: function checkLength(value, formValues) {
				var err = {
					min: {
						type: 'lengthMin',
						field: 'cbus_id',
						message: 'Cbus Member ID should contain minimum 7 digits'
					},
					max: {
						type: 'lengthMax',
						field: 'cbus_id',
						message: 'Cbus Member ID should contain maximum 10 digits'
					}
				};
				if (value.length < 7 && value.length > 0) return err.min;
				if (value.length > 10) return err.min;
			},
			skill_level_required: {
				type: 'required',
				field: 'preferred_sport',
				message: 'Preferred Sport - is required'
			},
			fox_tel_required: {
				type: 'required',
				field: 'foxtel_subscriber',
				message: 'Foxtel subscribe - is required'
			},
			sky_sports_required: {
				type: 'required',
				field: 'sky_sports',
				message: 'Foxtel subscribe - is required'
			},
			new_game_required: {
				type: 'required',
				field: 'foxtel_subscriber',
				message: 'Foxtel subscribe - is required'
			},
			gender_required: {
				type: 'required',
				field: 'gender',
				message: 'Gender - is required'
			},
			country_required: function(value, formValues) {
				var err = {
					type: 'required',
					field: 'country',
					message: 'Country is required'
				};
				if (!value || value==0) return err;
			},
			jmc_buy_vehicle_required: function(value, formValues) {
				var err = {
					type: 'required',
					field: 'jmc_buy_vehicle',
					message: 'This field is required'
				};
				if (!value || value==0) return err;
			},
			jmc_preferred_vehicle: function(value, formValues) {
				var err = {
					type: 'required',
					field: 'jmc_preferred_vehicle',
					message: 'This field is required'
				};
				if (!value || value=='') return err;
			},

			jmc_contact_required: function(value, formValues) {
				var err = {
					type: 'required',
					field: 'jmc_contact',
					message: 'This field is required'
				};
				if (!value || value=='') return err;
			},

			state_required: function checkCountry(value, formValues) {
				var err = {
					type: 'required',
					message: 'State is required for Australia'
				};
				if (formValues.state=='AU') return err;
			},
			postcode_check_country: function checkCountry(value, formValues) {
				var err = {
					type: 'required',
					field: 'postcode',
					message: 'Postcode is required for Australia'
				};
				if (formValues.country=='AU' && !value) return err;
			},
			postcode_length: function checkLength(value, formValues) {
				var err = {
					type: 'length',
					field: 'postcode',
					message: 'Postcode should contain maximum four characters'
				};
				if (formValues.country=='AU' && value.length > 4) return err;
			},
			postcode_us_only: function checkLength(value, formValues) {
				var err = {
					type: 'length',
					field: 'postcode',
					message: 'Postcode should contain five characters'
				};
				if (value.length != 5) return err;
			},

			postcode_required: function(value, formValues) {
				var err = {
					type: 'required',
					field: 'postcode',
					message: 'Postcode is required'
				};
				if (!value || value=='') return err;
			},
			user_name_required: {
				type: 'required',
				field: 'team_name',
				message: 'Username - is required field'
			},
			address_required: function(value, formValues) {
				var err = {
					type: 'required',
					field: 'address',
					message: 'Address - is required field for Western Australia'
				};
				if (formValues.state==='WA' && !value.length) return err;
			},
			zip_code_length: function checkLength(value, formValues) {
				var err = {
					type: 'length',
					field: 'postcode',
					message: 'Zip Code should contain maximum four characters'
				};
				if (formValues.country=='AU' && value.length > 4) return err;
			},
			zip_code_required: function(value, formValues) {
				var err = {
					type: 'required',
					field: 'postcode',
					message: 'Zip Code is required'
				};
				if (!value || value=='') return err;
			},
			zip_code_10_symbols: function(value) {
				var err = {
					type: 'length',
					field: 'postcode',
					message: 'Zip Code should contain maximum 10 characters'
				};
				if (value.length > 10) return err;
			},
			zip_code_special_chars: {
				type: 'regexp',
				field: 'postcode',
				regexp: /^[A-Za-z0-9]+$/,
				message: 'Zip Code should contain only letters and digits'

			},
			mobile_req_for_prizes: function(value, formValues) {
				let err = {
						type: 'required',
						message: 'Mobile is required for Australia'
					},
					today = new Date(),
					birthday = new Date(formValues.birthday),
					age = today.getFullYear() - birthday.getFullYear(),
					m = today.getMonth() - birthday.getMonth();
				if (m < 0 || (m===0 && today.getDate() < birthday.getDate())) {
					age--;
				}

				if (formValues.state==='WA' && !value.length && age >= 18) return err;
			},

			required_translated: {
				type: 'required',
				message: function() {
					return _.mixinTranslate('error_message_required', 'Required');
				}
			}

			// subscriber_wa_required: {
			// 	type: 'required',
			// 	field: 'subscriber_wa',
			// 	message: 'This checkbox is required'
			// },
			// subscriber_wa_required: function(value, formValues){
			// 	var err = {
			// 		type: 'required',
			// 		field: 'address',
			// 		message: 'Address - is required field for Western Australia'
			// 	};
			// 	if (formValues.state === 'WA' && !value.length) return err;
			// },
			// subscriber_st_required: {
			// 	type: 'required',
			// 	field: 'subscriber_st',
			// 	message: 'subscriber_st'
			// }
		},
		getValidationItems: function(options) {
			var validations = _.map(options, _.bind(function(value) {
				return this.get(value);
			}, this));
			return _.compact(validations);
		}
	});

}(window, APP, Backbone, Marionette, $, _));


